import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import { getSoldProducts } from "../../../actions/invoiceItem";
import { getAllLocation } from "../../../actions/warehouseAction";
import { getFilteredEntry } from "../../../actions/datewisebarcodeentryAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllContactMerchandiser } from "../../../actions/contactAction";
import ReactToPrint from "react-to-print";
import dateFormat from "dateformat";
import Excelldownload from "./Excelldownload";
import moment from "moment";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  Button,
  Layout,
  Breadcrumb,
  DatePicker,
  Spin,
  TreeSelect,
  Table,
  Input 
} from "antd";

const { RangePicker } = DatePicker;
const { Content } = Layout;
const { Option } = Select;

const SoldProduct = ({
  getSoldProducts,
  getAllLocation,
  businessprofile,
  Auth,
  getFilteredEntry,
  getAllContactMerchandiser,
  Merchandiser,
  getAllCategory,
  categorylist
}) => {
  const componentRef = useRef();
  const [data, setData] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initial, setInitial] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const location = useRef("");
  const marchand = useRef("");
  const category = useRef("");
  const start = useRef("");
  const end = useRef("");
  const keyword = useRef("");

  const onChange = (event) => {
    if (event.keyCode == 13) {
      keyword.current = event.target.value;
      setReload(!reload);
    }
  };

  useEffect(() => {
    getAllContactMerchandiser();
    getAllCategory();
    if (start.current !== "" || end.current !== "" || keyword.current!= "") {
      setLoading(true);
      getAllLocation().then((res) => {
        setLocations(res);
        getFilteredEntry(
          start.current,
          end.current,
          1,
          100000000,
          location.current,
          marchand.current,
          category.current,
          keyword.current
        ).then((result) => {
          setData(result.results);
          setLoading(false);
        });
      });
    } else {
      setInitial(true);
      getAllLocation().then((res) => {
        setLocations(res);
        setInitial(false);
      });
    }
  }, [reload]);

  useEffect(() => {
    const total = data.reduce((acc, item) => acc + item.quantity, 0);
    setTotalQuantity(total);
  }, [data]);

  const columns = [
    {
      title: "SL.",
      dataIndex: "index",
      key: "index",
      render: (text, record, index) => index + 1,
    },
    {
      title: "Date",
      dataIndex: "created",
      key: "created",
      render: (text) => moment(text).format("YYYY-MM-DD hh:mm A"),
    },
    // {
    //   title: "Supplier",
    //   dataIndex: "Merchandiser__name",
    //   key: "Merchandiser__name",
    // },
    {
      title: "Location",
      dataIndex: ["ProductLocation", "Warehouse_name"],
      key: "ProductLocation.Warehouse_name",
    },
    {
      title: "Product",
      dataIndex: ["ProductLocation", "title"],
      key: "ProductLocation.title",
    },
    {
      title: "Variation",
      dataIndex: ["ProductLocation", "Attribute_details"],
      key: "ProductLocation.Attribute_details",
    },
    {
      title: "Sub category",
      dataIndex: ["ProductLocation", "category"],
      key: "ProductLocation.category",
    },
    {
      title: "Product Code",
      dataIndex: ["ProductLocation", "ProductDetails", "product_code"],
      key: "ProductLocation.ProductDetails.product_code",
    },
    {
      title: "Selling Price",
      dataIndex: ["ProductLocation", "selling_price"],
      key: "ProductLocation.selling_price",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
    },
  ];

  return (
    <>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Report</Breadcrumb.Item>
        <Breadcrumb.Item>Products Entry Report</Breadcrumb.Item>
      </Breadcrumb>
      <div className="site-layout-background main-frame">
        <Spin spinning={initial}>
          <Row wrap={false}>
          <Col flex="auto">
              <h3>Keyword Search</h3>
              <Input
                placeholder="Search by keyword"
                onKeyDown={onChange} 
              />
            </Col>
            <Col flex="auto">
              <h3>Issue date :</h3>
              <RangePicker
                style={{ width: "100%" }}
                picker="date"
                onChange={(value) => {
                  if (value) {
                    start.current = value[0].format("YYYY-MM-DD") + "T00:00:00";
                    end.current = value[1].format("YYYY-MM-DD") + "T23:59:59";
                    setReload(!reload);
                  }
                }}
              />
            </Col>
            <Col flex="auto">
              <h3>Choose warehouse / outlet</h3>
              <Select
                placeholder="Please select an outlet / warehouse"
                style={{ width: "100%" }}
                onChange={(e) => {
                  location.current = e;
                  setLoading(true);
                  setReload(!reload);
                }}
              >
                <Option value="">All</Option>
                {locations.length > 0
                  ? locations[0].children.map((outlet) => {
                      return <Option key={outlet.id} value={outlet.id}>{outlet.name}</Option>;
                    })
                  : ""}
              </Select>
            </Col>


            <Col flex="auto">
              <h3>Choose Category</h3>
              <TreeSelect
                style={{ width: "100%" }}
                treeData={categorylist}
                onChange={(e) => {
                  category.current = e;
                  setLoading(true);
                  setReload(!reload);
                }}
              />
            </Col>
            <Col flex="auto">
              <h3>.</h3>
              <Excelldownload data={data} />
            </Col>
            <Col flex="auto">
              <h3>.</h3>
              <ReactToPrint
                trigger={() => (
                  <Button style={{ width: "100%" }} type="primary">
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </Col>
          </Row>
        </Spin>
        <Divider />
        <div><span color="green">Total Quantity: </span>{totalQuantity}</div>
        <Spin spinning={loading}>
          <Table
            ref={componentRef}
            dataSource={data}
            columns={columns}
            rowKey={(record) => record.id}
            pagination={{ pageSize: 10 }}
          />
        </Spin>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    categorylist: state.category.categorylist,
    businessprofile: state.settings.businessprofile,
    Auth: state.auth,
    Merchandiser: state.contacts.contactlistsearchresult,
  };
};

export default connect(mapStateToProps, {
  getSoldProducts,
  getAllLocation,
  getFilteredEntry,
  getAllContactMerchandiser,
  getAllCategory,
})(SoldProduct);
